import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { CloseIcon } from "../../icons";

const CryptoBottomSheet = ({
  isOpen,
  onClose,
  title,
  children,
  maxWidth = "max-w-[552px]",
  showHeader,
  panelClassName = "",
  contentClassName = "min-h-0 flex-1 overflow-y-auto hide-scrollbar",
}) => {
  const shouldShowHeader = showHeader ?? Boolean(title);

  return (
    <Transition.Root show={isOpen} as={Fragment} appear>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="transition-opacity duration-500 ease-out"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-300 ease-in"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/60 backdrop-blur-[3px]" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-y-auto overflow-x-hidden p-0 sm:p-5">
          <div className="flex min-h-full items-end justify-center sm:items-center">
            <Transition.Child
              as={Fragment}
              enter="transition duration-500 ease-[cubic-bezier(0.32,0.72,0,1)]"
              enterFrom="translate-y-full opacity-0 sm:translate-y-6 sm:scale-[0.98]"
              enterTo="translate-y-0 opacity-100 sm:scale-100"
              leave="transition duration-300 ease-in"
              leaveFrom="translate-y-0 opacity-100 sm:scale-100"
              leaveTo="translate-y-full opacity-0 sm:translate-y-6 sm:scale-[0.98]"
            >
              <Dialog.Panel className={`flex w-full ${maxWidth} flex-col sm:gap-3`}>
                <Transition.Child
                  as={Fragment}
                  enter="transition duration-300 ease-out delay-100"
                  enterFrom="opacity-0 -translate-y-2"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition duration-200 ease-in"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 -translate-y-2"
                >
                  <div className="flex w-full flex-col items-center sm:hidden">
                    <button
                      type="button"
                      onClick={onClose}
                      className="mb-4 flex size-10 shrink-0 items-center justify-center rounded-full bg-[#9CA3AF] shadow-[0_2px_8px_rgba(0,0,0,0.15)] custom-transition hover:bg-[#8B939E]"
                      aria-label="Close"
                    >
                      <CloseIcon className="text-white" />
                    </button>
                  </div>
                </Transition.Child>

                <div
                  className={`flex max-h-[85dvh] w-full transform-gpu flex-col overflow-hidden rounded-t-[24px] bg-background-surface py-[17px] shadow-[0_4px_24px_rgba(0,0,0,0.16)] will-change-transform sm:max-h-[560px] sm:rounded-[16px] ${panelClassName}`}
                >
                  {shouldShowHeader && (
                    <div className="flex h-12 shrink-0 items-center justify-between px-4 sm:px-6">
                      <Dialog.Title className="text-lg font-semibold leading-7 text-text-primary">
                        {title}
                      </Dialog.Title>
                      <button
                        type="button"
                        onClick={onClose}
                        className="hidden rounded-full p-0 custom-transition hover:bg-option-hover sm:block"
                        aria-label="Close"
                      >
                        <CloseIcon />
                      </button>
                    </div>
                  )}

                  <div className={contentClassName}>{children}</div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default CryptoBottomSheet;
